var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { AccordionSet, Accordion, Button, Checkbox, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { searchAgencyPublishers } from "../api/publisherService";
import { formatPublisherLabel } from "../utils/formatPublisherLabel";
import { RecekTextField, RecekSelect, RecekSelection } from "./inputs";
import { DateRangeFilterAccordions } from "./DateRangeFilterAccordions";
export function ProductNumberFilters(_a) {
    var temporaryPublisherFilter = _a.temporaryPublisherFilter, temporaryPublisherPrefixFilter = _a.temporaryPublisherPrefixFilter, temporaryProductNumberFilter = _a.temporaryProductNumberFilter, temporaryBlockedFilter = _a.temporaryBlockedFilter, temporaryDateRangeFilters = _a.temporaryDateRangeFilters, _b = _a.hasInvalidDateRange, hasInvalidDateRange = _b === void 0 ? false : _b, dateInputs = _a.dateInputs, publisherSearchQuery = _a.publisherSearchQuery, selectedPublisherData = _a.selectedPublisherData, selectedPublisherLoading = _a.selectedPublisherLoading, publisherPrefixesData = _a.publisherPrefixesData, publisherPrefixesLoading = _a.publisherPrefixesLoading, onPublisherFilterChange = _a.onPublisherFilterChange, onPublisherPrefixFilterChange = _a.onPublisherPrefixFilterChange, onProductNumberFilterChange = _a.onProductNumberFilterChange, onBlockedFilterChange = _a.onBlockedFilterChange, onDateRangeFilterChange = _a.onDateRangeFilterChange, onPublisherSearchInput = _a.onPublisherSearchInput, onApplyFilters = _a.onApplyFilters;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _c = useQuery(["publisherSearch", publisherSearchQuery], function () {
        return searchAgencyPublishers(ky, {
            query: publisherSearchQuery
                ? "name=\"".concat(publisherSearchQuery, "*\" or name=\"*").concat(publisherSearchQuery, "*\"")
                : "cql.allRecords=1",
            offset: 0,
            limit: 100,
        });
    }, {
        enabled: !!publisherSearchQuery.trim(),
        staleTime: 30000,
        select: function (data) { var _a; return (_a = data.items) !== null && _a !== void 0 ? _a : []; },
    }), publisherSearchResults = _c.data, publishersLoading = _c.isLoading;
    var publisherOptions = useMemo(function () { return __spreadArray(__spreadArray([
        {
            value: "",
            label: formatMessage({
                id: "ui-br-agency.collectionsList.select.option.all",
            }),
        }
    ], (selectedPublisherData
        ? [
            {
                value: selectedPublisherData.sourceId,
                label: formatPublisherLabel(selectedPublisherData, formatMessage),
            },
        ]
        : []), true), (publisherSearchResults || [])
        .filter(function (publisher) {
        return publisher.sourceId !== (selectedPublisherData === null || selectedPublisherData === void 0 ? void 0 : selectedPublisherData.sourceId);
    })
        .map(function (publisher) { return ({
        value: publisher.sourceId || "",
        label: formatPublisherLabel(publisher, formatMessage),
    }); }), true); }, [selectedPublisherData, publisherSearchResults, formatMessage]);
    var publisherPrefixOptions = useMemo(function () {
        var prefixes = (publisherPrefixesData === null || publisherPrefixesData === void 0 ? void 0 : publisherPrefixesData.items) || [];
        return __spreadArray([
            {
                value: "",
                label: formatMessage({
                    id: "ui-br-agency.collectionsList.select.option.all",
                }),
            }
        ], prefixes.map(function (prefix) { return ({
            value: prefix.id,
            label: prefix.value,
        }); }), true);
    }, [publisherPrefixesData, formatMessage]);
    return (React.createElement("form", { onSubmit: function (event) {
            event.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product-number.filter.section.publisher",
                }), separator: false },
                React.createElement(RecekSelection, { labelId: "ui-br-agency.product-number.filter.section.publisher", showLabel: false, asyncFilter: true, value: selectedPublisherData ? selectedPublisherData.sourceId : "", loading: publishersLoading || selectedPublisherLoading, onFilter: onPublisherSearchInput, onChange: onPublisherFilterChange, dataOptions: publisherOptions })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product-number.filter.section.publisherPrefix",
                }), separator: false },
                React.createElement(RecekSelect, { labelId: "ui-br-agency.product-number.filter.section.publisherPrefix", showLabel: false, value: temporaryPublisherPrefixFilter, onChange: function (event) {
                        return onPublisherPrefixFilterChange(event.target.value);
                    }, fullWidth: true, disabled: !temporaryPublisherFilter || publisherPrefixesLoading }, publisherPrefixOptions.map(function (option) { return (React.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product-number.filter.section.productNumber",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.filter.productNumber.label", showLabel: false, value: temporaryProductNumberFilter, onChange: function (event) {
                        return onProductNumberFilterChange(event.target.value);
                    }, fullWidth: true })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product-number.filter.section.blocked",
                }), separator: false },
                React.createElement(Checkbox, { checked: temporaryBlockedFilter === true, onChange: function (event) {
                        var isChecked = event.target.checked;
                        onBlockedFilterChange(isChecked ? true : undefined);
                    }, label: formatMessage({
                        id: "ui-br-agency.product-number.filter.blocked.label",
                    }) })),
            React.createElement(DateRangeFilterAccordions, { values: temporaryDateRangeFilters, onChange: onDateRangeFilterChange, invalidInputs: dateInputs.invalidInputs, onInvalidInputChange: dateInputs.setInputInvalid, inputsKey: dateInputs.inputsKey, labelIds: {
                    dateCreated: "ui-br-agency.product-number.filter.section.dateCreated",
                    dateUpdated: "ui-br-agency.product-number.filter.section.dateUpdated",
                }, idPrefix: "product-number-filter" })),
        React.createElement(Button, { type: "submit", disabled: hasInvalidDateRange, marginBottom0: true }, formatMessage({ id: "ui-br-agency.button.apply" }))));
}
